module.exports = __webpack_public_path__ + "img/agrogofincas.896e8d15.svg";